// extracted by mini-css-extract-plugin
export var numpadContainer = "_nd-1";
export var phoneButton = "_nd-0";